<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_vii"></a><em>Do not be afraid. I am the First and the Last. I am the Living One; I was dead, and behold I am alive and forever! And I hold the keys of death and Hades. Write, therefore, what you have seen, what is now and what will take place later.</em></p>
<p class="para"> </p>
<p class="para">This particular installation of the series is for anyone who believes that there is more out there than meets the naked eye . . . for people who intuitively know that this struggle of human existence, which has gone on since the very beginning of time, is not just a battle of physical and mental survival, but also involves the spirit. May love, peace, joy, Light, abundance, and a sense of the everlasting always reside in your spirit. As long as you have hope, you cannot be defeated.</p>
<p class="para"> </p>
<p class="para"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?078b9372